import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import CTA from 'react-scale/components/elements/cta';
import Button from 'react-scale/components/elements/button';
import Form from 'react-scale/components/pages/resources/detail/form';
import Modal from 'react-scale/components/tailwind/Modal';
import showModal from 'react-scale/components/tailwind/Modal/showModal';
import PreHero from 'react-scale/components/pages/interviews/pre-hero';

import styles from './hero.module.css';

const Hero = ({
  title,
  subtitle,
  description,
  image,
  modalTitle,
  portalId,
  formId,
  buttonText,
  downloadLink,
  downloadSubtitle,
  downloadValidation,
  directDownload,
  modalButtonText,
  slug
}) => {
  const [hasRegistered, setHasRegistered] = useState(false);
  const { isShowing, toggle } = showModal();

  useEffect(() => {
    const hasRegisteredStorage = window.localStorage.getItem('hasregistered');

    if (hasRegisteredStorage === slug) {
      setHasRegistered(true);
    }
  }, [isShowing]);

  return (
    <div>
      <PreHero type="Solution Briefs/White Papers" />
      <div className="max-w-5xl mx-auto">
        <p className="mx-auto mt-10 text-lg text-center lg:mt-14 lg:text-xl max-w-max text-transform-gradient">
          {subtitle}
        </p>
        <h2 className="mt-8 mb-16 text-4xl font-normal text-center font-aeonik md:text-4xl lg:text-5xl">
          {title}
        </h2>
        <div className="flex max-h-[500px] justify-center overflow-hidden rounded-xl">
          <Image
            className="rounded-xl"
            width={image.width}
            height={image.height}
            objectFit="cover"
            src={image.url}
            alt={image.alt}
          />
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="pb-16 text-center pt-14">
            {!hasRegistered && !directDownload && (
              <>
                <Button text={modalButtonText || buttonText || 'RSVP Now'} onClick={toggle} />
                {portalId !== '' && (
                  <Modal isShowing={isShowing} hide={toggle} title={modalTitle}>
                    <Form
                      portalId={portalId}
                      formId={formId}
                      hideModalAfterSubmit={toggle}
                      downloadValidation={downloadValidation}
                      slug={slug}
                    />
                  </Modal>
                )}
              </>
            )}

            {(hasRegistered && downloadSubtitle !== '') ||
            (directDownload && downloadSubtitle !== '') ? (
              <p className="mt-10 text-lg lg:mb-14 text-scale-mauve">{downloadSubtitle}</p>
            ) : null}

            {(hasRegistered && downloadLink !== '') || (directDownload && downloadLink !== '') ? (
              <div className="flex justify-center">
                <CTA
                  cta={{
                    buttons: [
                      {
                        text: buttonText || 'Download Now',
                        href: downloadLink,
                        type: 'primary'
                      }
                    ]
                  }}
                />
              </div>
            ) : null}
          </div>

          <ReactMarkdown className={`${styles.heroContent} text-lg`} rehypePlugins={[rehypeRaw]}>
            {description}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default Hero;
